import { useEffect, useState } from "react";
import axiosInstance from "../../../services/axiosComman";
import { TableLoader } from "../../../components/Loader";
import NuDateFormat from "../../../utils/NuDate";
import ViewMore from "./ViewMore";

function CertificationCalenderTracker() {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const refreshData = () => {
    setLoading(true);
    axiosInstance
      .get(`/Standards/`)
      .then((res) => {
        let tempdata = res?.data?.data || [];
        let finalArr = [];
        res?.data?.data &&
          tempdata.forEach((item) => {
            if (item?.isActive && item?.keyActivated) {
              if (
                item?.date_details != [] &&
                item?.date_details != null &&
                item?.date_details.length > 0
              ) {
                item?.date_details.map((i) => {
                  let temp = {
                    name: item?.name,
                    start_date: i?.start_date,
                    end_date: i?.end_date,
                    isActive: i?.isActive,
                    id: item?.id,
                    last_reset_date: item?.last_reset_date,
                  };
                  finalArr.push(temp);
                });
              } else {
                finalArr.push(item);
              }
            }
          });
        setLoading(false);
        res?.data?.data && setData(finalArr);
      })
      .catch((err) => {
        setLoading(false);
        console.error(
          err?.response?.data?.msg ||
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            "has error"
        );
      });
  };

  useEffect(() => {
    refreshData();
  }, []);
  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
            Certification Calendar Tracker
          </h4>
        </div>
        <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                  {header?.map((header) => (
                    <th className={`text-center px-5 py-4 ${header.width}`}>
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(10)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <>
                  {data &&
                    data.map((data, i) => (
                      <tr
                        className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                        key={i}
                      >
                        <td
                          className={`text-center text-gray-900 py-1 w-[10%]`}
                        >
                          {i + 1}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1 w-[45%]`}
                        >
                          {data.name || "-"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1 w-[20%]`}
                        >
                          {(data?.start_date != "None" &&
                            data?.start_date != " " &&
                            NuDateFormat({
                              value: data?.start_date,
                              format: "DD-MMM-yyyy",
                            })) ||
                            "-"}
                        </td>
                        <td
                          className={`text-center text-gray-900 py-1 w-[20%] flex justify-center items-center`}
                        >
                          {(data?.end_date != "None" &&
                            data?.end_date != " " &&
                            NuDateFormat({
                              value: data?.end_date,
                              format: "DD-MMM-yyyy",
                            })) ||
                            "-"}
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[5%]`}>
                          <div className=" w-full h-full flex justify-center items-center">
                            <ViewMore
                              data={data}
                              fetcher={refreshData}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CertificationCalenderTracker;

const header = [
  {
    headone: "SI. No",
    width: "w-[10%]",
  },
  {
    headone: "Standard Name",
    width: "w-[45%]",
  },
  {
    headone: "Start Date",
    width: "w-[20%]",
  },
  {
    headone: "End Date",
    width: "w-[20%]",
  },
  {
    headone: " ",
    width: "w-[5%]",
  },
];
